
  import { computed, defineComponent, PropType } from 'vue'
  import { useI18n } from 'vue-i18n'

  import RecordsCard from '@/components/Dashboard/UserRecords/RecordsCard.vue'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { getRecordsBySports } from '@/utils/records'
  import { translateSports } from '@/utils/sports'

  export default defineComponent({
    name: 'UserRecords',
    components: {
      RecordsCard,
    },
    props: {
      sports: {
        type: Object as PropType<ISport[]>,
        required: true,
      },
      user: {
        type: Object as PropType<IUserProfile>,
        required: true,
      },
    },
    setup(props) {
      const { t } = useI18n()
      const recordsBySport = computed(() =>
        getRecordsBySports(
          props.user.records,
          translateSports(props.sports, t),
          props.user.timezone
        )
      )
      return { recordsBySport }
    },
  })
